import { useContext } from 'react';
import { CopilotChannelContext } from '../channel/CopilotChannelContext';
export const useIsCopilotOpen = () => {
  const {
    channelState
  } = useContext(CopilotChannelContext);
  return channelState.isWidgetOpen;
};